import ProductivityDetail from './ProductivityDetail';

export default ProductivityDetail;
